module.exports = __webpack_public_path__ + "img/new-rest-message.5ec025c5.png";